<!--
 * @Author: your name
 * @Date: 2020-09-22 09:12:40
 * @LastEditTime: 2020-09-23 14:59:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \1-trunk\src\components\basics\case-process.vue
-->
<!-- 病例进度条 接收参数active(激活的项,从0开始)，data(数据) -->
<template>
  <div class="caseprocess">
    <el-steps :active="active" align-center>
      <el-step
        v-for="(item,key) in data"
        :key="key"
        :title="item.title"
        icon="el-icon-circle-check"
      ></el-step>
    </el-steps>
  </div>
</template>
<script>
// import { footerState, footerMutations } from '@vuex/footer'
export default {
  props: {
    active: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: () => {
        return [
          { title: '待申请' },
          { title: '已申请' },
          { title: '已退回' },
          { title: '已会诊' },
          { title: '已审核' }
        ];
      }
    }
  },
  data () {
    return {};
  },
  created () {},
  methods: {},
  watch: {},
  computed: {},
  components: {}
};
</script>
 <style lang="scss" scoped>
.caseprocess {
  width: 100%;
}
</style>
